<template>
  <div class="bg-stand" style="height: 100%">
    <top-header></top-header>
    <div class="page">
      <div class="sidebar">
        <sidebar></sidebar>
      </div>
      <div class="file">
        <files ref="files"></files>
      </div>
      <div class="file-info" v-show="$store.getters.SHOW_FILE_INFO">
        <div class="file-container">
          <h3>
            File Information
            <span @click="closefileinfo"><i class="fa fa-times"></i></span>
          </h3>
          <div>
            <fileinfo :data="$store.getters.GET_FILE_INFO_DATA"></fileinfo>
          </div>
          <div class="comment_preview">
            <viewcomments ref="commentpreview"></viewcomments>
          </div>
        </div>
      </div>
    </div>
    <invite ref="invite"></invite>
    <upload ref="upload"></upload>
    <createfile ref="createfile"></createfile>
    <addfavourite ref="addfavourite"></addfavourite>
    <pinfile ref="pinfile"></pinfile>
    <unpinfile ref="unpinfile"></unpinfile>
    <removefavourite ref="removefavourite"></removefavourite>
    <updatecountry ref="updatecountry"></updatecountry>
    <updatephone ref="updatephone"></updatephone>
    <renamefile ref="renamefile"></renamefile>
    <addcomment ref="addcomment"></addcomment>
    <deleteprompt ref="deleteprompt"></deleteprompt>
    <permanent ref="permanent"></permanent>
    <cantcreate ref="cant_create"></cantcreate>
    <playvideo ref="playvideo"></playvideo>
    <playaudio ref="playaudio"></playaudio>
    <viewfile ref="viewfile"></viewfile>
    <viewtxt ref="viewtxt"></viewtxt>
    <edittxt ref="edittxt"></edittxt>
    <closeupload ref="closeupload"></closeupload>
    <startupload ref="startupload"></startupload>
    <groupaddfavourite ref="groupaddfavourite"></groupaddfavourite>
    <groupdelete ref="groupdelete"></groupdelete>
    <grouptrashdeleteprompt ref="grouptrashdeleteprompt"></grouptrashdeleteprompt>
    <grouptrash ref="grouptrash"></grouptrash>
    <grouppermanent ref="grouppermanent"></grouppermanent>
    <browsefolder ref="browsefolder"></browsefolder>
    <viewpdf ref="viewpdf"></viewpdf>
    <deletefilepermanently ref="deletefilepermanently"></deletefilepermanently>
    <copyfile ref="copyfile"></copyfile>
    <copytoexist ref="copytoexist"></copytoexist>
    <movefile ref="movefile"></movefile>
    <movetoexist ref="movetoexist"></movetoexist>
    <compressfile ref="compressfile"></compressfile>
    <compressexist ref="compressexist"></compressexist>
    <uncompressexist ref="uncompressexist"></uncompressexist>
    <trashdeleteprompt ref="trashdelete"></trashdeleteprompt>
    <restorefile ref="restorefile"></restorefile>
    <grouprestore ref="grouprestore"></grouprestore>
    <groupbrowsefolder ref="groupbrowsefolder"></groupbrowsefolder>
    <groupcopyfile ref="groupcopyfile"></groupcopyfile>
    <groupmovefile ref="groupmovefile"></groupmovefile>
    <groupcopytoexist ref="groupcopytoexist"></groupcopytoexist>
    <promptcompressrename ref="promptcompressrename"></promptcompressrename>
    <groupcompressexist ref="groupcompressexist"></groupcompressexist>
    <addusertofolder ref="addusertofolder"></addusertofolder>
    <editusertofolder ref="editusertofolder"></editusertofolder>
    <useraddedtofolder ref="useraddedtofolder"></useraddedtofolder>
    <uncompressfile ref="uncompressfile"></uncompressfile>
    <editcomment ref="editcomment"></editcomment>
    <comments ref="comments"></comments>
    <sharefile ref="sharefile"></sharefile>
    <editsharefileright ref="editsharefileright"></editsharefileright>
    <trash ref="trash"></trash>
    <login ref="login"></login>
    <notify ref="notify"></notify>
    <search-file ref="searchfile"></search-file>
    <replycomment ref="replycomment"></replycomment>
    <loader ref="load"></loader>
    <splash ref="splash"></splash>
    <embeded ref="embed"></embeded>
    <logout ref="logout"></logout>
    <!--<audio autoplay="autoplay">
      <source src="../../media/just-saying.mp3" type="audio/mpeg">
    </audio>-->
  </div>
</template>
<style scoped>
.canvas {
  width: 100%;
  height: 100%;
  right: 0;
  position: fixed;
  box-shadow: rgba(0, 0, 0, 0.22) 0px 25.6px 57.6px 0px,
    rgba(0, 0, 0, 0.18) 0px 4.8px 14.4px 0px;
}

.headerbox {
  display: flex;
  align-items: center;
  background: #f9f9fa;
  border-bottom: 1px solid #edf2f7;
  height: 3rem;
  padding-left: 12px;
}

.w-full {
  width: 100%;
}

.h-full {
  height: 100%;
}
</style>
<script>
// @ is an alias to /src
import headerb from "@/components/Header";
import sidebar from "@/components/Sidebar";
import files from "@/components/Files";
import upload from "@/components/Upload";
import createfile from "@/components/CreateFile";
import fileinfo from "@/components/FileInfo";
import viewcomments from "@/components/View-Comments";
import comments from "@/components/Comments";
import addfavourite from "@/components/Add-Favourite";
import pinfile from "@/components/Pin-File";
import unpinfile from "@/components/Unpin-File";
import removefavourite from "@/components/Remove-Favourite";
import renamefile from "@/components/Rename-File";
import { mapMutations } from "vuex";
import login from "@/components/Login";
import updatephone from "@/components/Update-Phone";
import updatecountry from "@/components/Update-Country";
import addcomment from "@/components/Add-Comment";
import deleteprompt from "@/components/Delete-Prompt";
import trashdeleteprompt from "@/components/Trash-Delete-Prompt";
import grouptrashdeleteprompt from "@/components/Group-Trash-Delete-Prompt";
import grouprestore from "@/components/Group-Restore";
import permanent from "@/components/Permanent";
import trash from "@/components/Trash";
import grouppermanent from "@/components/Group-Permanent";
import grouptrash from "@/components/Group-Trash";
import cantcreate from "@/components/CantCreate";
import playvideo from "@/components/Play-Video";
import playaudio from "@/components/Play-Audio";
import viewfile from "@/components/View-File";
import viewtxt from "@/components/View-Txt";
import edittxt from "@/components/Edit-Txt";
import closeupload from "@/components/Close-Upload";
import deletefilepermanently from "@/components/DeleteFilePermanently";
import startupload from "@/components/Start-Upload";
import groupaddfavourite from "@/components/Group-Add-Favourite";
import groupdelete from "@/components/Group-Delete";
import browsefolder from "@/components/Browse-Folder";
import copyfile from "@/components/CopyFile";
import copytoexist from "@/components/CopyToExist";
import movefile from "@/components/MoveFile";
import compressfile from "@/components/Compress-File";
import compressexist from "@/components/Compress-Exist";
import uncompressexist from "@/components/Uncompress-Exist";
import groupcompressexist from "@/components/Group-Compress-Exist";
import promptcompressrename from "@/components/Prompt-Compress-Rename";
import restorefile from "@/components/Restore-File";
import movetoexist from "@/components/MoveToExist";
import viewpdf from "@/components/View-Pdf";
import groupbrowsefolder from "@/components/Group-Browse-Folder";
import groupcopyfile from "@/components/Group-Copy-File";
import groupmovefile from "@/components/Group-Move-File";
import groupcopytoexist from "@/components/Group-Copy-To-Exist";
import addusertofolder from "@/components/Add-User-To-Folder";
import editusertofolder from "@/components/Edit-User-To-Folder";
import uncompressfile from "@/components/Uncompress-File";
import {
  createGroupFolderObservers,
  approveGroupFolderObservers,
  sharedFileObservers,
  createInsideGroupFolderObservers,
  createFileObservers,
  copyFileObservers,
} from "@/Observers.js";
import useraddedtofolder from "@/components/User-Added-To-Folder";
import sharefile from "@/components/Share-File";
import notify from "@/components/Notify";
import SearchFile from "@/components/SearchFile";
import logout from "@/components/Logout";
import loader from "@/components/Loading";
import replycomment from "@/components/Reply-Comment";
import editcomment from "@/components/Edit-Comment";
import editsharefileright from "@/components/Edit-Share-File-Rights";
import headerbox from "@/components/Header-Box";
import config from "@/services/config";
import cookies from "@/services/cookies";
import splash from "@/components/Splash-Screen";
import embeded from "@/components/Embed";
import invite from "@/components/Invite";
import TopHeader from "@/components/Top-Header";

export default {
  name: "home",
  components: {
    editsharefileright,
    replycomment,
    TopHeader,
    sidebar,
    comments,
    editcomment,
    files,
    closeupload,
    upload,
    createfile,
    fileinfo,
    viewcomments,
    addfavourite,
    removefavourite,
    pinfile,
    unpinfile,
    renamefile,
    login,
    updatecountry,
    updatephone,
    addcomment,
    deleteprompt,
    trashdeleteprompt,
    permanent,
    trash,
    cantcreate,
    playvideo,
    playaudio,
    viewfile,
    viewtxt,
    edittxt,
    deletefilepermanently,
    startupload,
    groupaddfavourite,
    groupdelete,
    grouppermanent,
    grouptrash,
    browsefolder,
    copyfile,
    copytoexist,
    movefile,
    movetoexist,
    compressfile,
    compressexist,
    grouptrashdeleteprompt,
    restorefile,
    viewpdf,
    grouprestore,
    groupbrowsefolder,
    groupcopyfile,
    groupcopytoexist,
    groupcompressexist,
    groupmovefile,
    promptcompressrename,
    addusertofolder,
    editusertofolder,
    uncompressfile,
    uncompressexist,
    useraddedtofolder,
    sharefile,
    notify,
    logout,
    SearchFile,
    loader,
    splash,
    headerbox,
    invite,
    embeded,
  },
  data() {
    return {
      audiosrc: "",
      chat: false,
      firstname: localStorage.getItem("firstname"),
      lastname: localStorage.getItem("lastname"),
      department: localStorage.getItem("department"),
      position: localStorage.getItem("position"),
      account_type: localStorage.getItem("account_type"),
    };
  },
  computed: {
    src() {
      return process.env.VUE_APP_NODE_ENV === "development"
        ? "https://192.168.1.2:9009/embed"
        : "https://app.fexspace.com/embed";
    },
  },
  methods: {
    set_view_type(type) {
      this.$refs.files.set_view_type(type);
      // alert(type);
    },
    getPhoto(photo) {
      const pt = `${this.backendUrl}/static-photos/${photo}`;
      return pt;
    },
    getInitials(name) {
      const nm = name.first;
      return nm.charAt(0);
    },
    notifyexpiration(text) {
      this.$refs.notify.load(text);
    },
    closebox() {
      if (this.$store.getters.SHOW_CHAT) {
        this.TOGGLE_CHAT();
      }

      if (this.$store.getters.SHOW_NOTE) {
        this.TOGGLE_NOTE();
      }

      if (this.$store.getters.SHOW_NOTIFICATION) {
        this.TOGGLE_NOTIFICATION();
      }
    },
    invite() {
      this.$refs.invite.load();
    },
    playsound() {
      let au = new Audio("@/assets/just-saying.mp3");
      au.play();
    },
    loading(click) {
      this.$refs.load.load(click);
    },
    loading_close() {
      this.$refs.load.close();
    },
    comments(fileId) {
      this.$refs.comments.load(fileId);
    },
    editcomment(name, data) {
      this.$refs.editcomment.load(name, data);
    },
    ...mapMutations([
      "SET_FILE_ACTION",
      "REMOVE_FILE_ACTION",
      "SET_DIRECTORY_CHILDREN",
      "TOGGLE_FILE_INFO",
      "TOGGLE_CHAT",
      "TOGGLE_NOTE",
      "TOGGLE_NOTIFICATION",
      "SORT_DIRECTORY_CHILDREN",
      "SORT_STORED_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "GET_DIRECTORY_CHILDREN",
      "CLOSE_FILE_INFO",
      "SET_PATH",
      "UPDATE_SLIDEIN",
      "UPDATE_SLIDEOUT",
      "UPDATE_BODY_MENU",
      "UPDATE_MENU",
      "UPDATE_TOTAL_CREATED_IMAGES",
      "UPDATE_TOTAL_CREATED_DOCUMENTS",
      "UPDATE_TOTAL_CREATED_FOLDERS",
      "SET_FIRSTNAME",
      "SET_LASTNAME",
      "SET_EMAIL",
      "SET_PHONE",
      "SET_POSITION",
      "SET_DEPARTMENT",
      "SET_COUNTRY",
      "SET_DATE_CREATED",
      "SET_ACCT_TYPE",
      "SET_ISADMIN",
      "SET_PHOTO",
      "UPDATE_TOTAL_SPACE",
      "UPDATE_DEFAULT_FOLDER",
      "UPDATE_TOTAL_USED_SPACE",
      "SET_ISTRIAL",
      "SET_ISSTAFF",
      "SET_ISSUPERADMIN",
      "SET_PATH",
      "SORT_DIRECTORY_CHILDREN",
      "SET_CURRENT_DIRECTORY",
      "HIDE_FILE_INFO",
      "SET_FILE_ACTION",
      "SET_SELECT_ALL",
      "SET_DB",
      "UPDATE_DIRECTORY_CHILDREN",
      "UPDATE_USER",
      "SET_NAME",
      "SET_CAN_CREATE",
      "SET_CREATE_RIGHT",
      "SET_PRINT_RIGHT",
      "SET_CURRENT_PLAN",
      "EMPTY_FILES_INDEX",
      "ADD_NOTIFICATION",
      "UPDATE_NOTIFICATION_COUNT",
      "UPDATE_SHARED_WITH_ME_COUNT",
      "SORT_NOTIFICATION",
      "UPDATE_NOTIFICATION",
      "SET_PERSONAL_SCROLL",
      "SET_FULL_LINK",
      "SET_MIN_LINK",
      "SET_USER_PLAN",
      "UPDATE_PUBLIC_FOLDER_ID",
      "SET_IS_SECURITY_QUESTION",
      "SET_CREATE_RIGHT",
      "SET_EDIT_RIGHT",
      "SET_DOWNLOAD_RIGHT",
      "SET_PRINT_RIGHT",
      "SET_GROUP_CREATE_MODE",
      "SET_COMPANY",
      "SET_PLAN_STATUS",
      "SET_TRIAL_STATUS",
      "SET_REFERRAL_LINK",
      "SET_HAS_ON_BOARDED",
      "SET_HAS_CRM",
      "SET_HAS_INVEX",
      "SET_INVEX_DOMAIN",
      "SET_INVEX_API_URL"
    ]),
    replycomment(comment) {
      this.$refs.replycomment.load(comment);
    },
    load() {
      this.$refs.load.load();
    },
    close_load() {
      this.$refs.load.close();
    },
    searchfile() {
      this.$refs.searchfile.load();
    },
    closesearchfile() {
      this.$refs.searchfile.close();
    },
    do_upload_cancel() {
      this.$refs.upload.cancel_uploads();
    },
    back() {
      let data = {
        token: cookies.getCookie("token"),
      };

      let that = this;
      this.SET_FILE_ACTION("");

      this.$socket.emit("loadmainfiles", data, function (data) {
        if (data.data === true) {
          localStorage.setItem(
            "current_directory_id",
            data.current_directory_id
          );
          localStorage.setItem("current_directory", data.current_directory);
          localStorage.setItem("db", "filesystem");
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_CURRENT_DIRECTORY(data.current_directory);
          that.SET_PATH([]);
          that.SORT_DIRECTORY_CHILDREN();
        }

        if (data.data === false) {
          that.logincall();
          sessionStorage.removeItem("status");
        }
      });
    },
    file_exist(
      index,
      copy_file_id = "",
      selected_folder_id = "",
      new_name,
      type
    ) {
      if (type == "copy") {
        this.$refs.copytoexist.loader(
          copy_file_id,
          selected_folder_id,
          new_name
        );
      }

      if (type == "move") {
        this.$refs.movetoexist.loader(
          index,
          copy_file_id,
          selected_folder_id,
          new_name
        );
      }

      if (type == "compress") {
        this.$refs.compressexist.loader(index, new_name);
      }

      if (type == "uncompress") {
        this.$refs.uncompressexist.loader(index, new_name);
      }
    },
    group_compress_file_exist(name, old_name, ids) {
      this.$refs.groupcompressexist.loader(name, old_name, ids);
    },
    group_file_exist(
      selected_folder_id = "",
      selected_folder_name,
      old_name,
      new_name,
      copy_files,
      current_file_id,
      type
    ) {
      if (type === "copy") {
        this.$refs.groupcopytoexist.loader(
          selected_folder_id,
          selected_folder_name,
          new_name,
          old_name,
          copy_files,
          current_file_id
        );
      }

      if (type === "move") {
      }
    },
    notify(text) {
      this.$refs.notify.load(text);
    },
    useradded() {
      this.$refs.useraddedtofolder.load();
    },
    addusertofolder(folder_id, folder_name, await_status) {
      this.$refs.addusertofolder.load(folder_id, folder_name, await_status);
    },
    editusertofolder(folder_id, folder_name) {
      this.$refs.editusertofolder.load(folder_id, folder_name);
    },
    copyfile(index, location_id, location, db, is_shared = false) {
      this.$refs.copyfile.load(index, location_id, location, db, is_shared);
    },
    movefile(index, location_id, location, db) {
      this.$refs.movefile.load(index, location_id, location, db);
    },
    groupcopyfile(location_id, location) {
      this.$refs.groupcopyfile.load(location_id, location);
    },
    groupmovefile(location_id, location) {
      this.$refs.groupmovefile.load(location_id, location);
    },
    promptcompressrename() {
      this.$refs.promptcompressrename.load();
    },
    compressfile(index, src) {
      this.$refs.compressfile.load(index, src);
    },
    uncompressfile(index) {
      this.$refs.uncompressfile.load(index);
    },
    view_file(index, id) {
      this.$refs.viewfile.load(index, id);
    },
    sharefile(index = null, is_group = false) {
      this.$refs.sharefile.load(index, is_group);
    },
    editsharefileright(data, index) {
      this.$refs.editsharefileright.load(data, index);
    },
    play_video(index, id) {
      this.$refs.playvideo.load(id);
    },
    play_audio(index, id) {
      this.$refs.playaudio.load(id);
    },
    close_upload(files) {
      this.$refs.closeupload.load(files);
    },
    change_pic() {
      this.UPDATE_SLIDEIN(false);
      this.UPDATE_SLIDEOUT(true);
      this.UPDATE_MENU(false);
      this.UPDATE_BODY_MENU(false);

      this.$refs.pic.click();
    },
    group_add_to_favourite() {
      this.$refs.groupaddfavourite.add();
    },
    start_upload() {
      this.$refs.startupload.load(this.$refs.pic.files[0]);
      this.$refs.pic.value = "";
    },
    add_comment(name, id) {
      this.$refs.addcomment.load(name, id, true);
    },
    slideout($evt) {
      if ($evt.target.tagName === "svg" || $evt.target.tagName === "path") {
        this.UPDATE_SLIDEIN(false);
        this.UPDATE_SLIDEOUT(true);
        this.UPDATE_MENU(false);
        this.UPDATE_BODY_MENU(false);
      } else {
        if ($evt.target.classList.contains("menubody")) {
          this.UPDATE_SLIDEIN(false);
          this.UPDATE_SLIDEOUT(true);
          this.UPDATE_MENU(false);
          this.UPDATE_BODY_MENU(false);
        }
      }
    },
    viewpdf(id, rights = null) {
      this.$refs.viewpdf.load(id, rights);
    },
    view_txt(index, id) {
      this.$refs.viewtxt.load(index, id);
    },
    view_file_doc(id, right, db) {
      if (db === "group") {
        if (right === "edit") {
          let a = document.createElement("a");
          a.setAttribute(
            "href",
            process.env.VUE_APP_HTTP +
            "://" +
            location.host +
            "/group-edit-doc/" +
            id
          );
          a.setAttribute("target", "_blank");
          a.hidden = true;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          let a = document.createElement("a");
          a.setAttribute(
            "href",
            process.env.VUE_APP_HTTP +
            "://" +
            location.host +
            "/group-view-doc/" +
            id
          );
          a.setAttribute("target", "_blank");
          a.hidden = true;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }

      if (db === "filesystem") {
        let a = document.createElement("a");
        a.setAttribute(
          "href",
          process.env.VUE_APP_HTTP + "://" + location.host + "/edit-doc/" + id
        );
        a.setAttribute("target", "_blank");
        a.hidden = true;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }

      if (db === "public") {
        let a = document.createElement("a");
        a.setAttribute(
          "href",
          process.env.VUE_APP_HTTP +
          "://" +
          location.host +
          "/public-edit-doc/" +
          id
        );
        a.setAttribute("target", "_blank");
        a.hidden = true;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }

      if (db === "sharedwithme") {
        let a = document.createElement("a");
        if (right === "edit") {
          a.setAttribute(
            "href",
            process.env.VUE_APP_HTTP +
            "://" +
            location.host +
            "/shared-edit-doc/" +
            id
          );
        } else {
          a.setAttribute(
            "href",
            process.env.VUE_APP_HTTP +
            "://" +
            location.host +
            "/shared-view-doc/" +
            id
          );
        }
        a.setAttribute("target", "_blank");
        a.hidden = true;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
    edit_txt(index, id) {
      this.$refs.edittxt.load(index, id);
    },
    deletefilepermanently(index, prompt = "") {
      this.$refs.deletefilepermanently.load(index, prompt);
    },
    restorefile(index) {
      this.$refs.restorefile.load(index);
    },
    updatephone() {
      this.$refs.updatephone.load();
    },
    updatecountry() {
      this.$refs.updatecountry.load();
    },
    logincall() {
      this.$refs.login.load();
    },
    closefileinfo() {
      this.CLOSE_FILE_INFO();
    },
    upload(file, id = null) {
      this.$refs.upload.load(file, id);
    },
    cant_create(name) {
      this.$refs.cant_create.load(name);
    },
    create(type) {
      this.$refs.createfile.load(type);
    },
    loadCommentPreview(id) {
      this.$refs.commentpreview.load(id);
    },
    pinfile(index, id) {
      this.$refs.pinfile.pin(index, id);
    },
    unpinfile(index, id) {
      this.$refs.unpinfile.pin(index, id);
    },
    add_favourite(index, id) {
      this.$refs.addfavourite.add(index, id);
    },
    remove_favourite(index, id) {
      this.$refs.removefavourite.remove(index, id);
    },
    renamefile(index, name, id, base) {
      this.$refs.renamefile.rename(index, name, id, base);
    },
    copyto(index, is_shared = false) {
      this.$refs.browsefolder.load(index, "copy", is_shared);
    },
    moveto(index) {
      this.$refs.browsefolder.load(index, "move");
    },
    group_copyto() {
      this.$refs.groupbrowsefolder.load("copy");
    },
    group_moveto() {
      this.$refs.groupbrowsefolder.load("move");
    },
    group_delete() {
      this.$refs.groupdelete.load();
    },
    grouptrashdeleteprompt() {
      this.$refs.grouptrashdeleteprompt.load();
    },
    grouprestore() {
      this.$refs.grouprestore.load();
    },
    deletefile(index, id, src) {
      this.$refs.deleteprompt.load(index, id, src);
    },
    permanent(index, id, src) {
      this.$refs.permanent.load(index, id, src);
    },
    trash(index, id, src) {
      this.$refs.trash.load(index, id, src);
    },
    trashdeleteprompt(index, id) {
      this.$refs.trashdelete.load(index, id, "group");
    },
    grouppermanent(index, id) {
      this.$refs.grouppermanent.load();
    },
    grouptrash(index, id) {
      this.$refs.grouptrash.load();
    },
    onload() {
      let doc = document.querySelector("#eb-chat");
      doc.contentWindow.postMessage(cookies.getCookie("token"), "*");
    },
    user_data() {
      let data = {
        token: cookies.getCookie("token"),
      };

      let that = this;

      this.$socket.emit("get-data", data, function (data) {
        if (data.data === true) {
          that.SET_ACCT_TYPE(data.account_type);
          that.SET_ISADMIN(data.isSuperAdmin);
          that.SET_FIRSTNAME(data.firstname);
          that.SET_LASTNAME(data.lastname);
          that.SET_NAME(data.firstname + " " + data.lastname);
          that.SET_EMAIL(data.email);
          that.SET_PHONE(data.phone);
          that.SET_POSITION(data.position);
          that.SET_DEPARTMENT(data.department);
          that.SET_COMPANY(data.company);
          that.SET_COUNTRY(data.country ? data.country : "");
          that.SET_DATE_CREATED(data.date_created);
          that.SET_PHOTO(data.photo);
          that.UPDATE_TOTAL_SPACE(data.total_space);
          that.UPDATE_TOTAL_USED_SPACE(data.total_space_used);
          that.UPDATE_USER(data.id);
          that.SET_CURRENT_PLAN(data.current_plan);
          that.SET_USER_PLAN(data.user_plan);
          that.SET_PLAN_STATUS(data.isPlanActive);
          that.SET_TRIAL_STATUS(data.isTrialActive);
          that.SET_REFERRAL_LINK(
            process.env.VUE_APP_REFERRAL + data.referral_link
          );
          that.SET_HAS_CRM(data.hasCrm);
          that.SET_HAS_INVEX(data.hasInvex);
          that.SET_INVEX_DOMAIN(data.invex_domain);
          that.SET_INVEX_API_URL(data.invex_api_url);

          that.SET_HAS_ON_BOARDED(data.has_on_boarded);

          that.SET_ISTRIAL(data.isTrial);
          that.SET_ISSTAFF(data.isStaff);
          that.SET_ISSUPERADMIN(data.isSuperAdmin);

          that.SET_IS_SECURITY_QUESTION(data.is_security_question);

          that.UPDATE_DEFAULT_FOLDER(data.default_folders);

          that.UPDATE_PUBLIC_FOLDER_ID(data.public_folder_id);

          localStorage.setItem("email", data.email);
          localStorage.setItem(
            "is_security_question",
            data.is_security_question
          );
          sessionStorage.setItem("gi", data.group_folder_id);
          sessionStorage.setItem("pi", data.project_folder_id);

          that.UPDATE_TOTAL_CREATED_IMAGES(data.total_created_images);
          that.UPDATE_TOTAL_CREATED_DOCUMENTS(data.total_created_documents);
          that.UPDATE_TOTAL_CREATED_FOLDERS(data.total_created_folders);
        }
      });
    },
    logout() {
      this.UPDATE_SLIDEIN(false);
      this.UPDATE_SLIDEOUT(true);
      this.UPDATE_MENU(false);
      this.UPDATE_BODY_MENU(false);
      this.$refs.logout.logout();
    },
  },
  created() {
    let that = this;
    window.addEventListener("resize", function () {
      if (window.innerWidth < 1200) {
        that.SET_FULL_LINK(false);
        that.SET_MIN_LINK(true);
      } else {
        that.SET_FULL_LINK(true);
        that.SET_MIN_LINK(false);
      }

      if (window.innerHeight < 680) {
        that.SET_PERSONAL_SCROLL(true);
      } else {
        that.SET_PERSONAL_SCROLL(false);
      }
    });
  },
  mounted() {
    let that = this;

    this.$refs.splash.load();

    if (this.$route.params.id) {
      if (this.$route.params.id == "shared-with-me") {
        let data = {
          token: cookies.getCookie("token"),
        };

        this.SET_FILE_ACTION("");
        this.HIDE_FILE_INFO();
        this.SET_SELECT_ALL(false);
        this.EMPTY_FILES_INDEX();

        let that = this;

        this.$socket.emit("get-shared-with", data, function (data) {
          if (data.data === true) {
            that.$refs.splash.close();
            localStorage.setItem("current_directory_id", "");
            localStorage.setItem("current_directory", "Shared With Me");
            localStorage.setItem("db", "sharedwithme");
            that.SET_DB("sharedwithme");
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_CURRENT_DIRECTORY("Shared With Me");
            that.SET_PATH(data.dir_path);
            that.SORT_DIRECTORY_CHILDREN();
          }

          if (data.data === false) {
            that.$refs.splash.close();
            that.logincall();
            sessionStorage.removeItem("status");
          }
        });

        this.user_data();
        return;
      }

      if (
        cookies.getCookie("token") === null ||
        cookies.getCookie("token") === undefined ||
        cookies.getCookie("token") === ""
      ) {
        this.$router.push("/login");
      }

      if (
        this.$route.params.id !== "undefined" &&
        this.$route.params.id !== null &&
        this.$route.params.id !== "" &&
        this.$route.params.id !== undefined
      ) {
        let data = {
          token: cookies.getCookie("token"),
          id: this.$route.params.id,
        };

        this.$socket.emit("current-directory", data, function (data) {
          if (data.data === true) {
            that.$refs.splash.close();

            localStorage.setItem(
              "current_directory_id",
              data.current_directory_id
            );
            localStorage.setItem("current_directory", data.current_directory);
            that.SET_DB(localStorage.getItem("db"));
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();

            if (data.group === "PERSONAL" || data.group === "PUBLIC") {
              if (data.group === "PERSONAL") {
                sessionStorage.setItem("db", "filesystem");
              }

              if (data.group === "PUBLIC") {
                sessionStorage.setItem("db", "public");
              }
              that.SET_DB(sessionStorage.getItem("db"));
              that.SET_CREATE_RIGHT(true);
              that.SET_CAN_CREATE(true);
              that.SET_EDIT_RIGHT(true);
              that.SET_DOWNLOAD_RIGHT(true);
              that.SET_PRINT_RIGHT(true);
            } else {
              sessionStorage.setItem("db", "group");
              if (
                (data.group === "GROUP" || data.group === "PROJECT") &&
                String(data.current_directory_id) ===
                String(sessionStorage.getItem("gi"))
              ) {
                sessionStorage.setItem("is_group", true);
                sessionStorage.setItem("create_mode", true);
                that.SET_GROUP_CREATE_MODE(
                  sessionStorage.getItem("create_mode")
                );
              } else {
                sessionStorage.setItem("group_create", data.create_right);
                sessionStorage.setItem("create", data.create_right);
                sessionStorage.removeItem("create_mode");
                sessionStorage.setItem("is_group", true);
                that.SET_GROUP_CREATE_MODE(false);
              }

              if (data.group === "GROUP" || data.group === "PROJECT") {
                that.SET_CREATE_RIGHT(sessionStorage.getItem("group_create"));
                that.SET_DB(sessionStorage.getItem("db"));
                that.SET_CAN_CREATE(sessionStorage.getItem("create"));
                that.SET_EDIT_RIGHT(data.edit_right);
                that.SET_DOWNLOAD_RIGHT(data.download_right);
                that.SET_PRINT_RIGHT(data.print_right);
              }
            }

            that.SET_PATH(data.dir_path);
          }

          if (data.data === false) {
            that.$router.push("login");
            sessionStorage.removeItem("status");
          }
        });
      } else {
        let data = {
          token: cookies.getCookie("token"),
        };

        this.$socket.emit("eb:auth", data, function (data) {
          if (data.data === true) {
            that.$refs.splash.close();
            localStorage.setItem(
              "current_directory_id",
              data.current_directory_id
            );
            localStorage.setItem("current_directory", data.current_directory);
            localStorage.setItem("db", "filesystem");
            that.SET_DB("filesystem");
            that.SET_PATH([]);
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();
          }

          if (data.data === false) {
            that.$router.push("login");
            sessionStorage.removeItem("status");
          }
        });
      }

      copyFileObservers.subscribe((data) => {
        let items = Object.keys(that.$store.getters.GET_FILES_INDEX);
        delete that.$store.getters.GET_FILES_INDEX[data.id];

        if (data.type === "move") {
          let files = that.$store.getters.DIRECTORY_CHILDREN.filter((file) => {
            if (file.id !== data.id) {
              file.is_checked = false;
              return file;
            }
          });

          that.SET_DIRECTORY_CHILDREN(files);
          that.SET_STORED_DIRECTORY_CHILDREN(files);
          that.SORT_DIRECTORY_CHILDREN();
        }
      });

      sharedFileObservers.subscribe((data) => {
        if (data.who.includes(localStorage.getItem("id"))) {
          let dataText = {
            id: data.message.id,
            text: data.message.message,
            is_checked: data.message.is_checked,
            is_read: data.message.is_read,
            createdAt: data.message.createAt,
          };
          that.UPDATE_NOTIFICATION(dataText);
          let notification = that.$store.getters.NOTIFICATION;
          let countnote = notification.map((note) => {
            if (!note.is_checked.includes(localStorage.getItem("id"))) {
              return true;
            }
          });
          that.UPDATE_NOTIFICATION_COUNT(countnote.length);
          // that.SORT_NOTIFICATION()
          let count = that.$store.getters.SHARED_WITH_ME_COUNT;
          ++count;
          that.UPDATE_SHARED_WITH_ME_COUNT(count);
        }
      });

      createFileObservers.subscribe((data) => {
        let files = that.$store.getters.DIRECTORY_CHILDREN.map((file) => {
          return file.id;
        });

        if (
          localStorage.getItem("current_directory_id") == data.parent_directory
        ) {
          if (
            !files.includes(data.directory_children.id) &&
            data.who.includes(localStorage.getItem("id"))
          ) {
            that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();
          }
        }
      });

      createGroupFolderObservers.subscribe((data) => {
        if (data.who.includes(localStorage.getItem("id"))) {
          that.ADD_NOTIFICATION(data.message);
        }
      });

      this.user_data();

      let data = {
        token: cookies.getCookie("token"),
      };

      this.$socket.emit("eb:notification", data, function (data) {
        if (data.data === true) {
          let count = data.notifications.filter((note) => {
            if (!note.is_checked.includes(localStorage.getItem("id"))) {
              return true;
            }
          });

          that.UPDATE_NOTIFICATION_COUNT(count.length);
          that.ADD_NOTIFICATION(data.notifications);
        }
      });

      const iframenote = this.$refs.iframe_note;
      // view = 'note'|'chat'
      iframenote.addEventListener("load", () => {
        iframenote.contentWindow.postMessage({ view: "note" }, "*");
      });

      const iframechat = this.$refs.iframe_chat;
      // view = 'note'|'chat'
      iframechat.addEventListener("load", () => {
        iframechat.contentWindow.postMessage({ view: "chat" }, "*");
      });

      window.addEventListener("keyup", function (e) {
        if (e.which === 27) {
          if (that.$store.getters.SHOW_CHAT) {
            that.TOGGLE_CHAT();
          }

          if (that.$store.getters.SHOW_NOTE) {
            that.TOGGLE_NOTE();
          }
        }
      });
    } else {
      if (
        cookies.getCookie("token") === null ||
        cookies.getCookie("token") === undefined ||
        cookies.getCookie("token") === ""
      ) {
        this.$router.push("/login");
      }

      copyFileObservers.subscribe((data) => {
        let items = Object.keys(that.$store.getters.GET_FILES_INDEX);
        delete that.$store.getters.GET_FILES_INDEX[data.id];

        if (data.type === "move") {
          let files = that.$store.getters.DIRECTORY_CHILDREN.filter((file) => {
            if (file.id !== data.id) {
              file.is_checked = false;
              return file;
            }
          });

          that.SET_DIRECTORY_CHILDREN(files);
          that.SET_STORED_DIRECTORY_CHILDREN(files);
          that.SORT_DIRECTORY_CHILDREN();
        }
      });

      sharedFileObservers.subscribe((data) => {
        if (data.who.includes(localStorage.getItem("id"))) {
          let dataText = {
            id: data.message.id,
            text: data.message.message,
            is_checked: data.message.is_checked,
            is_read: data.message.is_read,
            createdAt: data.message.createAt,
          };
          that.UPDATE_NOTIFICATION(dataText);
          let notification = that.$store.getters.NOTIFICATION;
          let countnote = notification.map((note) => {
            if (!note.is_checked.includes(localStorage.getItem("id"))) {
              return true;
            }
          });
          that.UPDATE_NOTIFICATION_COUNT(countnote.length);
          // that.SORT_NOTIFICATION()
          let count = that.$store.getters.SHARED_WITH_ME_COUNT;
          ++count;
          that.UPDATE_SHARED_WITH_ME_COUNT(count);
        }
      });

      createFileObservers.subscribe((data) => {
        // console.log(data)
        let files = that.$store.getters.DIRECTORY_CHILDREN.map((file) => {
          return file.id;
        });

        if (
          localStorage.getItem("current_directory_id") == data.parent_directory
        ) {
          if (
            !files.includes(data.directory_children.id) &&
            data.who.includes(localStorage.getItem("id"))
          ) {
            that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();
          }
        }
      });

      createGroupFolderObservers.subscribe((data) => {
        // console.log(data)
        if (data.who.includes(localStorage.getItem("id"))) {
          // console.log(data.message)
          // that.ADD_NOTIFICATION(data.message)
        }
      });

      approveGroupFolderObservers.subscribe((data) => {
        if (data.who.includes(localStorage.getItem("id"))) {
        }
      });

      this.user_data();

      if (
        localStorage.getItem("current_directory_id") !== "undefined" &&
        localStorage.getItem("current_directory_id") != null &&
        localStorage.getItem("current_directory_id") != ""
      ) {
        let data = {
          token: cookies.getCookie("token"),
          current_directory_id: localStorage.getItem("current_directory_id"),
          db: localStorage.getItem("db"),
        };

        this.$socket.emit("get-current-directory", data, function (data) {
          if (data.data === true) {
            that.$refs.splash.close();
            localStorage.setItem(
              "current_directory_id",
              data.current_directory_id
            );
            localStorage.setItem("current_directory", data.current_directory);
            that.SET_DB(localStorage.getItem("db"));
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SORT_DIRECTORY_CHILDREN();

            if (
              (data.group == "GROUP" || data.group == "PROJECT") &&
              String(data.current_directory_id) ===
              String(sessionStorage.getItem("gi"))
            ) {
              sessionStorage.setItem("is_group", true);
              sessionStorage.setItem("create_mode", true);
              that.SET_GROUP_CREATE_MODE(sessionStorage.getItem("create_mode"));
            } else {
              sessionStorage.setItem("group_create", data.create_right);
              sessionStorage.removeItem("create_mode");
              sessionStorage.setItem("is_group", true);
              that.SET_GROUP_CREATE_MODE(false);
            }

            if (data.group === "GROUP" || data.group === "PROJECT") {
              that.SET_CREATE_RIGHT(sessionStorage.getItem("group_create"));
              that.SET_DB(sessionStorage.getItem("group"));
              that.SET_CAN_CREATE(sessionStorage.getItem("create"));
              that.SET_EDIT_RIGHT(data.edit_right);
              that.SET_DOWNLOAD_RIGHT(data.download_right);
              that.SET_PRINT_RIGHT(data.print_right);
            }

            that.SET_PATH(data.dir_path);
          }

          if (data.data === false) {
            that.$router.push("login");
            sessionStorage.removeItem("status");
          }
        });
      } else {
        if (localStorage.getItem("db") !== null) {
          if (localStorage.getItem("db") === "sharedwithme") {
            let data = {
              token: cookies.getCookie("token"),
            };

            this.SET_FILE_ACTION("");
            this.HIDE_FILE_INFO();
            this.SET_SELECT_ALL(false);
            this.EMPTY_FILES_INDEX();

            let that = this;

            this.$socket.emit("get-shared-with", data, function (data) {
              if (data.data === true) {
                that.$refs.splash.close();
                localStorage.setItem("current_directory_id", "");
                localStorage.setItem("current_directory", "Shared With Me");
                localStorage.setItem("db", "sharedwithme");
                that.SET_DB("sharedwithme");
                that.SET_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_CURRENT_DIRECTORY("Shared With Me");
                that.SET_PATH(data.dir_path);
                that.SORT_DIRECTORY_CHILDREN();
              }

              if (data.data === false) {
                that.$refs.splash.close();
                that.logincall();
                sessionStorage.removeItem("status");
              }
            });
          }

          if (localStorage.getItem("db") === "sharedfiles") {
            let data = {
              token: cookies.getCookie("token"),
            };

            this.SET_FILE_ACTION("");
            this.HIDE_FILE_INFO();
            this.SET_SELECT_ALL(false);
            this.EMPTY_FILES_INDEX();

            let that = this;

            this.$socket.emit("get-shared-files", data, function (data) {
              if (data.data === true) {
                that.$refs.splash.close();
                localStorage.setItem("current_directory_id", "");
                localStorage.setItem("current_directory", "Shared Files");
                localStorage.setItem("db", "sharedfiles");
                that.SET_DB("sharedfiles");
                that.SET_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_CURRENT_DIRECTORY("Shared Files");
                that.SET_PATH(data.dir_path);
                that.SORT_DIRECTORY_CHILDREN();
              }

              if (data.data === false) {
                that.$refs.splash.close();
                that.logincall(true);
                sessionStorage.removeItem("status");
              }
            });
          }

          if (localStorage.getItem("db") === "public") {
            let data = {
              token: cookies.getCookie("token"),
              db: localStorage.getItem("db"),
            };

            this.SET_FILE_ACTION("");
            this.HIDE_FILE_INFO();
            this.SET_SELECT_ALL(false);

            let that = this;

            this.$socket.emit("browse-public", data, function (data) {
              if (data.data === true) {
                that.$refs.splash.close();
                localStorage.setItem("current_directory_id", "");
                localStorage.setItem("current_directory", "Public");
                localStorage.setItem("db", "public");
                that.SET_DB("public");
                that.SET_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_CURRENT_DIRECTORY("Public");
                that.SET_PATH(data.dir_path);
                that.SORT_DIRECTORY_CHILDREN();
              }

              if (data.data === false) {
                that.$router.push("login");
                sessionStorage.removeItem("status");
              }
            });
          }

          if (localStorage.getItem("db") === "trash") {
            let data = {
              token: cookies.getCookie("token"),
            };

            this.SET_FILE_ACTION("");
            this.HIDE_FILE_INFO();
            this.SET_SELECT_ALL(false);

            let that = this;

            this.$socket.emit("get-trash-files", data, function (data) {
              if (data.data === true) {
                that.$refs.splash.close();
                localStorage.setItem("current_directory_id", "");
                localStorage.setItem("current_directory", "Trash");
                localStorage.setItem("db", "trash");
                that.SET_DB("filesystem");
                that.SET_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_CURRENT_DIRECTORY("Trash");
                that.SET_PATH(data.dir_path);
                that.SORT_DIRECTORY_CHILDREN();
              }

              if (data.data === false) {
                that.$router.push("login");
                sessionStorage.removeItem("status");
              }
            });
          }

          if (localStorage.getItem("db") === "favourite") {
            this.HIDE_FILE_INFO();
            this.SET_FILE_ACTION("");
            this.SET_SELECT_ALL(false);

            let data = {
              token: cookies.getCookie("token"),
            };

            let that = this;

            this.$socket.emit("myfav", data, function (data) {
              if (data.data === true) {
                that.$refs.splash.close();
                localStorage.setItem("current_directory", "My Favourite");
                localStorage.setItem("db", "favourite");
                that.SET_DB("filesystem");
                that.SET_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_CURRENT_DIRECTORY("My Favourite");
                that.SET_PATH(data.dir_path);
                that.SORT_DIRECTORY_CHILDREN();
              }

              if (data.data === false) {
                that.$router.push("login");
                sessionStorage.removeItem("status");
              }
            });
          }

          if (localStorage.getItem("db") === "group") {
            if (localStorage.getItem("current_directory_id") === undefined) {
              let data = {
                token: cookies.getCookie("token"),
                db: "group",
              };

              this.$socket.emit("browse", data, function (data) {
                if (data.data === true) {
                  that.$refs.splash.close();
                  localStorage.setItem("current_directory_id", undefined);
                  localStorage.setItem("current_directory", "Group");
                  localStorage.setItem("db", "group");
                  that.SET_DB("group");
                  that.SET_CAN_CREATE(false);
                  that.SET_DIRECTORY_CHILDREN(data.directory_children);
                  that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
                  that.SET_CURRENT_DIRECTORY("Group");
                  that.SET_PATH(data.dir_path);
                  that.SORT_DIRECTORY_CHILDREN();
                }

                if (data.data === false) {
                  that.$router.push("login");
                  sessionStorage.removeItem("status");
                }
              });
            } else {
              let data = {
                token: cookies.getCookie("token"),
                current_directory_id: localStorage.getItem(
                  "current_directory_id"
                ),
                db: "group",
              };

              this.$socket.emit("browse", data, function (data) {
                if (data.data === true) {
                  that.$refs.splash.close();
                  that.SET_DIRECTORY_CHILDREN(data.directory_children);
                  that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
                  that.SORT_DIRECTORY_CHILDREN();
                }

                if (data.data === false) {
                  that.$router.push("login");
                  sessionStorage.removeItem("status");
                }
              });
            }
          }

          if (localStorage.getItem("db") === "filesystem") {
            let data = {
              token: cookies.getCookie("token"),
            };

            this.$socket.emit("eb:auth", data, function (data) {
              console.log("90902");
              if (data.data === true) {
                that.$refs.splash.close();
                localStorage.setItem(
                  "current_directory_id",
                  data.current_directory_id
                );
                localStorage.setItem(
                  "current_directory",
                  data.current_directory
                );
                localStorage.setItem("db", "filesystem");
                that.SET_DB("filesystem");
                that.SET_PATH([]);
                that.SET_DIRECTORY_CHILDREN(data.directory_children);
                that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
                that.SORT_DIRECTORY_CHILDREN();
              }

              if (data.data === false) {
                that.$router.push("login");
                sessionStorage.removeItem("status");
              }
            });
          }
        } else {
          let data = {
            token: cookies.getCookie("token"),
          };

          this.$socket.emit("eb:auth", data, function (data) {
            console.log("loca");
            if (data.data === true) {
              that.$refs.splash.close();
              localStorage.setItem(
                "current_directory_id",
                data.current_directory_id
              );
              localStorage.setItem("current_directory", data.current_directory);
              localStorage.setItem("db", "filesystem");
              that.SET_DB("filesystem");
              that.SET_PATH([]);
              that.SET_DIRECTORY_CHILDREN(data.directory_children);
              that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
              that.SORT_DIRECTORY_CHILDREN();
            }

            if (data.data === false) {
              that.$router.push("login");
              sessionStorage.removeItem("status");
            }
          });
        }
      }

      let data = {
        token: cookies.getCookie("token"),
      };

      this.$socket.emit("eb:notification", data, function (data) {
        if (data.data === true) {
          let count = data.notifications.filter((note) => {
            if (!note.is_checked.includes(localStorage.getItem("id"))) {
              return true;
            }
          });

          that.UPDATE_NOTIFICATION_COUNT(count.length);
          that.ADD_NOTIFICATION(data.notifications);
        }
      });

      const iframenote = this.$refs.iframe_note;
      // view = 'note'|'chat'
      iframenote.addEventListener("load", () => {
        iframenote.contentWindow.postMessage({ view: "note" }, "*");
      });

      const iframechat = this.$refs.iframe_chat;
      // view = 'note'|'chat'
      iframechat.addEventListener("load", () => {
        iframechat.contentWindow.postMessage({ view: "chat" }, "*");
      });

      window.addEventListener("keyup", function (e) {
        if (e.which === 27) {
          if (that.$store.getters.SHOW_CHAT) {
            that.TOGGLE_CHAT();
          }

          if (that.$store.getters.SHOW_NOTE) {
            that.TOGGLE_NOTE();
          }
        }
      });
    }
  },
};
</script>
